import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "styled-components";
import { formatNumber } from "@wrstudios/utils";
import { getHighestZestimateDifferences } from "../../../utils/listings";
import {
  Container,
  ContainerInner,
  Graph,
  Bars,
  Bar,
  Legends,
  Legend,
  LegendValue
} from "./styled/live-online-valuations-chart";

function LiveOnlineValuationsChart({
  listings,
  hoverListingId,
  setHoverListingId,
  setPreviewListingId
}) {
  const theme = useTheme();
  const highestZestimateDifference = getHighestZestimateDifferences(listings);
  const colorSpectrum = theme.getColorSpectrumFromColor(
    (listings[0] || { statusColor: "#000" }).statusColor
  );

  return (
    <Container>
      <ContainerInner>
        <Graph>
          <Legends>
            <Legend>
              <LegendValue>
                +
                {formatNumber(
                  highestZestimateDifference.priceDifferencePercentage,
                  "0.[0]"
                )}
                %
              </LegendValue>
            </Legend>
            <Legend color={colorSpectrum[200]}>
              <LegendValue isCenter>0%</LegendValue>
            </Legend>
            <Legend>
              <LegendValue>
                -{formatNumber(highestZestimateDifference, "0.[0]")}%
              </LegendValue>
            </Legend>
          </Legends>
          <Bars style={{ maxWidth: listings.length > 10 ? "80rem" : "50rem" }}>
            {listings
              .filter((listing) => listing.zestimate.priceDifferencePercentage)
              .map((listing, index) => {
                const isFirst = index === 0;
                const isHovering = listing.recordId === hoverListingId;
                const height =
                  (listing.zestimate.priceDifferencePercentage /
                    highestZestimateDifference.priceDifferencePercentage) *
                  100;
                const isNegative = height < 0;

                return (
                  <Bar
                    key={listing.recordId}
                    style={{
                      height: `${Math.abs(height)}%`,
                      marginLeft: isFirst
                        ? 0
                        : listings.length < 10
                        ? "8%"
                        : listings.length < 15
                        ? "4%"
                        : "2%",
                      transform: isNegative ? "translateY(100%)" : null,
                      borderRadius: isNegative ? "0 0 0.3rem 0.3rem" : null
                    }}
                    isGhost={listing.isGhost}
                    isHovering={isHovering}
                    statusColor={listing.statusColor}
                    onMouseEnter={() => setHoverListingId(listing.recordId)}
                    onMouseLeave={() => setHoverListingId(null)}
                    onClick={() => setPreviewListingId(listing.recordId)}
                  />
                );
              })}
          </Bars>
        </Graph>
      </ContainerInner>
    </Container>
  );
}

LiveOnlineValuationsChart.propTypes = {
  listings: PropTypes.array.isRequired,
  hoverListingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default LiveOnlineValuationsChart;
